module.exports = __webpack_public_path__ + "img/diva of the lake.a61502f1.png";